import { CaDialogComponent } from '../../../shared/dialogs/ca-dialog.base'
import { Component, Inject } from '@angular/core'
import { UsersControllerService } from '../../../api/auth'
import { DialogService } from '../../../core/services/dialog.service'
import { ErrorService } from '../../../core/services/error.service'
import { CommonConstants } from '../../../constants/common.constants'

@Component({
    selector: 'ca-password-reset-dialog',
    template: `
        <div class="curtain">
            <section class="component-modalDialog redesigned size-5">
                <header>
                    Zapomenuté heslo
                    <a class="closeModalDialog fa fa-close" (click)="close()"></a>
                </header>
                <div class="contentContainer">
                    <div class="col-5 no-height" *ngIf="!sending">
                        <p class="message">Vyplňte uživatelské jméno, ke kterému jste zapomněli heslo.</p>
                    </div>
                    <form *ngIf="!sending">
                        <div class="col-5 no-height">
                            <input
                                [(ngModel)]="username"
                                type="text"
                                name="username"
                                placeholder="uživatelské jméno (e-mail)"
                                maxlength="255"
                                required
                                [pattern]="emailRegex"
                                (blur)="onUsernameBlur()"
                                autofocus>
                        </div>
                        <div class="floatClearer"></div>
                    </form>
                    <div class="col-5 no-height" *ngIf="!sending">
                        <p>
                            Máte problémy s přihlášením? Potřebujete poradit?
                            <a id="test-helpdeskLink" (click)="showHelpdesk();">Kontaktujte nás.</a>
                        </p>
                    </div>
                    <ca-loading [loadState]="sending" loadText="Odesílám..."></ca-loading>
                </div>
                <footer>
                    <a class="button-primary" (click)="sendRequest()">Odeslat požadavek na změnu hesla</a>
                    <a class="button-secondary" (click)="close()">Nic nedělat a zavřít</a>
                </footer>
            </section>
        </div>`,
    standalone: false
})
export class PasswordResetDialogComponent extends CaDialogComponent<{ username: string }, string> {
    username: string
    sending: boolean

    emailRegex: RegExp = CommonConstants.EMAIL_REGEX

    constructor(
        @Inject(UsersControllerService) private usersControllerService: UsersControllerService,
        @Inject(DialogService) private dialogService: DialogService,
        @Inject(ErrorService) private errorService: ErrorService,
    ) {
        super()
    }

    onUsernameBlur(): void {
        this.username = this.username.toLowerCase()
    }

    sendRequest(): void {
        if (!this.username) {
            this.dialogService.showWarningDialog('Je třeba zadat uživatelské jméno.')
            return
        } else if (!this.emailRegex.test(this.username)) {
            this.dialogService.showWarningDialog('Uživatelské jméno není platná emailová adresa.')
            return
        }
        this.sending = true
        this.usersControllerService
            .requestPasswordReset(this.username)
            .subscribe(() => {
                this.result = this.username
                this.close()
            }, (error) => {
                this.sending = false
                this.errorService.onErrorResponseAlertUser(error)
            })

    }

    showHelpdesk(): void {
        this.result = 'helpdesk'
        this.close()
    }
}